/**
 * @generated SignedSource<<eb7ea3f49a5750a597b7cccc9d474194>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ReactionsCommentsQuery_comment$data = {
  readonly id: string;
  readonly reactionsSummary: {
    readonly ari: string;
    readonly containerAri: string;
    readonly reactionsCount: number;
    readonly reactionsSummaryForEmoji: ReadonlyArray<{
      readonly count: number;
      readonly emojiId: string;
      readonly id: string;
      readonly reacted: boolean;
    } | null>;
  } | null;
  readonly " $fragmentType": "ReactionsCommentsQuery_comment";
};
export type ReactionsCommentsQuery_comment$key = {
  readonly " $data"?: ReactionsCommentsQuery_comment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReactionsCommentsQuery_comment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "containerId"
    }
  ],
  "kind": "Fragment",
  "name": "ReactionsCommentsQuery_comment",
  "selections": [
    (v0/*: any*/),
    {
      "args": [
        {
          "kind": "Literal",
          "name": "childType",
          "value": "comment"
        },
        {
          "kind": "Literal",
          "name": "contentType",
          "value": "page"
        },
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "containerId"
        }
      ],
      "concreteType": "ReactionsSummaryResponse",
      "kind": "LinkedField",
      "name": "reactionsSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "reactionsCount"
        },
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        {
          "kind": "ScalarField",
          "name": "containerAri"
        },
        {
          "concreteType": "ReactionsSummaryForEmoji",
          "kind": "LinkedField",
          "name": "reactionsSummaryForEmoji",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "emojiId"
            },
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "reacted"
            },
            (v0/*: any*/)
          ]
        }
      ]
    }
  ],
  "type": "Comment"
};
})();

(node as any).hash = "af213ff403659043868c02fbd688a22c";

export default node;
